module.exports = __webpack_public_path__ + "img/presion.adaa1468.svg";